import {Component, ViewChild} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {Observable, SubscriptionLike} from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {MatSidenav} from "@angular/material/sidenav";
import {AppComponent} from "../../../app.component";
import {ListItem} from "../../../objects/listItem";
import {SharedDataService} from "../../../services/shared-data.service";
import {environment} from "../../../../environments/environment";
import {AppEvent} from "../../../objects/appEvent";
import {User} from "../../../objects/user";
import {DialogCanvasComponent} from "../../dialog-canvas/dialog-canvas.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";

@Component({
  selector: 'app-mobile-container',
  templateUrl: './mobile-container.component.html',
  styleUrls: ['./mobile-container.component.scss']
})
export class MobileContainerComponent {

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  @ViewChild('drawer') drawer: MatSidenav;

  reason = '';
  private sharedEventSubscription: SubscriptionLike;
  private showMyProfile = false;
  private relationStatus = '';
  public viewerStateLabel:string = '';
  public isClassOwner = false;
  public isTrainerLogin = false;
  public profileClassRelation = '';
  public classConfig = null;
  public hideExitButton = false;
  public hideToolbar = false;
  public hideBackButton = false;

  private _state = 'default'; // login,files,error
  public get state(): string {
    return this._state;
  }
  public set state(value: string) {
    if(this._state == value) {
      return;
    }
    let oldState = this._state;
    this._state = value;
    let appEvent = new AppEvent(AppEvent.MOBILE_STATE_CHANGE, {oldState: oldState, newState: this._state});
    this.sharedDataService.pushAppEvent(appEvent)
    if(oldState == 'class_view') {
      this.isClassOwner = false;
      this.profileClassRelation = '';
      this.classConfig = null;
    }
    if(['class_view','profile_edit','trainers_widget','sms_login'].includes(this.state)) {
      this.hideExitButton = true;
    } else {
      this.hideExitButton = false;
    }
    if(this.application.getUrlParam('show_cup_players')) {
      this.hideToolbar = true;
    } else {
      this.hideToolbar = false;
    }
  }

  public viewID;

  close(reason: string) {
    this.reason = reason;
    this.drawer.close();
  }

  goToMyProfile() {
    if(this.drawer.opened) {
      this.drawer.toggle()
    }
    this.application.router.navigateByUrl('/squash/userview/'+this.application.user.id)
  }
  goToState(state) {
    if(this.drawer.opened) {
      this.drawer.toggle()
    }
    switch (state) {
      case 'squash_default':
        this.application.router.navigateByUrl('/squash')
        break;
      case 'profile_edit':
        this.application.router.navigateByUrl('/squash/profile_edit')
        break;
      case 'subscribe_events':
        this.application.router.navigateByUrl('/squash/subscribe_events')
        break;
      case 'cups':
        this.application.router.navigateByUrl('/squash/cups')
        break;
      case 'classes':
        this.application.router.navigateByUrl('/squash/classes')
        break;
    }
  }
  goToUserBookings(user:User) {
    if(this.drawer.opened) { this.drawer.toggle() }
    this.application.router.navigateByUrl('/squash/userview_bookings/'+user.id)
  }
  goToUserFriends(user:User) {
    if(this.drawer.opened) { this.drawer.toggle() }
    this.application.router.navigateByUrl('/squash/userview_friends/'+user.id)
  }
  goToUserGroups(user:User) {
    if(this.drawer.opened) { this.drawer.toggle() }
    this.application.router.navigateByUrl('/squash/userview_groups/'+user.id)
  }
  goToMySchedule() {
    if(this.drawer.opened) { this.drawer.toggle() }
    this.application.router.navigateByUrl('/squash/my_schedule')
  }
  goToTrainers() {
    if(this.drawer.opened) { this.drawer.toggle() }
    this.application.router.navigateByUrl('/squash/trainers')
  }
  goBack() {
    if(window.history.length <= 1) {
      this.application.router.navigateByUrl('/squash')
    } else {
      window.history.back()
    }
  }

  constructor(public application: AppComponent, public dialog: MatDialog,
              private sharedDataService: SharedDataService,
              private breakpointObserver: BreakpointObserver) {}

  ngOnInit(): void {
    this.sharedEventSubscription = this.sharedDataService.globalEventObservable$.subscribe(
      appEvent => {
        if (appEvent.type === AppEvent.USER_HAS_BEEN_LOGGED) {
          this.isTrainerLogin = User.isTrainer(this.application.user);
          console.log('this.isTrainerLogin',this.isTrainerLogin);
        }
        if (appEvent.type === AppEvent.SELECTED_USER_LOADED) {
          //this.showMyProfile = (appEvent.data['userID'] == this.viewID);
          this.showMyProfile = appEvent.data['showMyProfile'];
          this.viewerStateLabel = AppComponent.getLabel(appEvent.data['mobileViewerStateLabelKey'])
          this.relationStatus = User.getRelationStatus(this.application.user,appEvent.data['userID']);
        }
        if (appEvent.type === AppEvent.CLASS_CHECKED) {
          this.isClassOwner = appEvent.data['isClassOwner'];
          this.profileClassRelation = appEvent.data['profileClassRelation'];
          this.classConfig = appEvent.data['classConfig'];
          if(this.classConfig['type'] == 'cup') { //todo: remove in future
            this.hideBackButton = true;
          }
        }
      });
    //console.log('urlAfterRedirects',this.application.urlAfterRedirects)
    this.application.route.url.subscribe((url: any) => this.urlChange(url));
  }
  ngOnDestroy(): void {
    this.sharedEventSubscription.unsubscribe();
  }
  urlChange(url: any): void {
    switch (this.application.urlAfterRedirects) {
      case '/squash':
        this.state = 'squash_default';
        break;
      case '/squash/subscribe_events':
        this.state = 'subscribe_events';
        break;
      case '/squash/profile_edit':
        this.state = 'profile_edit';
        break;
      case '/squash/cups':
        this.state = 'cups';
        break;
      case '/squash/classes':
        this.state = 'classes';
        break;
      case '/squash/calendar':
        this.state = 'calendar';
        break;
      case '/squash/my_schedule':
        this.state = 'my_schedule';
        break;
      case '/squash/trainers':
        this.state = 'trainers';
        break;
      case '/trainers_widget':
        this.state = 'trainers_widget';
        break;
      case '/sms_login':
        this.state = 'sms_login';
        break;
      default:
        let viewMatch;
        if(viewMatch = this.application.urlAfterRedirects.match(/^\/squash\/userview\/(.+)/)) {
          this.viewID = viewMatch[1];
          this.state = 'user_view';
          let appEvent = new AppEvent(AppEvent.USER_SELECTED, {"userID":viewMatch[1]});
          this.sharedDataService.pushAppEvent(appEvent)
        }
        if(viewMatch = this.application.urlAfterRedirects.match(/^\/squash\/userview_bookings\/(.+)/)) {
          this.viewID = viewMatch[1];
          this.state = 'user_view_bookings';
          let appEvent = new AppEvent(AppEvent.USER_SELECTED, {"userID":viewMatch[1]});
          this.sharedDataService.pushAppEvent(appEvent)
        }
        if(viewMatch = this.application.urlAfterRedirects.match(/^\/squash\/userview_friends\/(.+)/)) {
          this.viewID = viewMatch[1];
          this.state = 'user_view_friends';
          let appEvent = new AppEvent(AppEvent.USER_SELECTED, {"userID":viewMatch[1]});
          this.sharedDataService.pushAppEvent(appEvent)
        }
        if(viewMatch = this.application.urlAfterRedirects.match(/^\/squash\/userview_groups\/(.+)/)) {
          this.viewID = viewMatch[1];
          this.state = 'user_view_groups';
          let appEvent = new AppEvent(AppEvent.USER_SELECTED, {"userID":viewMatch[1]});
          this.sharedDataService.pushAppEvent(appEvent)
        }
        if(viewMatch = this.application.urlAfterRedirects.match(/^\/squash\/classview\/(.+)/)) {
          this.viewID = viewMatch[1];
          this.state = 'class_view';
          let appEvent = new AppEvent(AppEvent.CLASS_SELECTED, {"classID":viewMatch[1]});
          this.sharedDataService.pushAppEvent(appEvent)

        }
        //trainerview_booking deprecated for now
        if(viewMatch = this.application.urlAfterRedirects.match(/^\/squash\/trainerview_booking\/(.+)/)) {
          this.viewID = viewMatch[1];
          this.state = 'trainer_booking';
          let appEvent = new AppEvent(AppEvent.USER_SELECTED, {"userID":viewMatch[1]});
          this.sharedDataService.pushAppEvent(appEvent)
        }
        if(viewMatch = this.application.urlAfterRedirects.match(/^\/squash\/trainerview\/(.+)/)) {
          this.viewID = viewMatch[1];
          this.state = 'trainer_view';
          let appEvent = new AppEvent(AppEvent.USER_SELECTED, {"userID":viewMatch[1]});
          this.sharedDataService.pushAppEvent(appEvent)
        }
    }
  }

  public userActionButtonClick() {
    let appEvent;
    switch (this.state) {
      case 'user_view':
        appEvent = new AppEvent(AppEvent.USER_EDIT_START_ACTION, {"userID":this.application.user.id});
        this.sharedDataService.pushAppEvent(appEvent)
        break;
      case 'user_view_bookings':
        appEvent = new AppEvent(AppEvent.USER_BOOKINGS_START_ACTION, {"userID":this.application.user.id});
        this.sharedDataService.pushAppEvent(appEvent)
        break;
      case 'user_view_friends':
        appEvent = new AppEvent(AppEvent.FRIEND_INVITE_START_ACTION, {"userID":this.application.user.id});
        this.sharedDataService.pushAppEvent(appEvent)
        break;
      case 'user_view_groups':
        appEvent = new AppEvent(AppEvent.GROUP_ADD_START_ACTION, {"userID":this.application.user.id});
        this.sharedDataService.pushAppEvent(appEvent)
        break;
    }
  }
  public otherUserActionButtonClick() {
    let appEvent = new AppEvent(AppEvent.OTHER_USER_ACTION, {"userID":this.viewID});
    this.sharedDataService.pushAppEvent(appEvent)
  }

  public addTrainerScheduleAction(trainerID) {
    let appEvent = new AppEvent(AppEvent.ADD_TRAINER_SCHEDULE, {"trainerID": trainerID});
    this.sharedDataService.pushAppEvent(appEvent)
  }

  public myScheduleAction() {
    let appEvent = new AppEvent(AppEvent.ADD_SCHEDULE, {});
    this.sharedDataService.pushAppEvent(appEvent)
  }

  public saveProfile() {
    let appEvent = new AppEvent(AppEvent.SAVE_PROFILE, {});
    this.sharedDataService.pushAppEvent(appEvent)
  }

  public dispatchClassMenuEvent(menuEvent) {
    let appEvent = new AppEvent(AppEvent.CLASS_MENU_EVENT, {"menuEvent":menuEvent});
    this.sharedDataService.pushAppEvent(appEvent)
  }

  public exit() {
    //environment['mobile_exit_strategy']
    if(!environment['mobile_exit_strategy']) {
      window.alert('missing mobile_exit_strategy');
      return;
    }

    if(environment['mobile_exit_strategy'] === 'viber') {
      let exit_context = '__exit_web_app';
      window.open(environment['viber_url']+exit_context)
    }
  }

}
